
import PrismicData from '~/assets/js/prismic-controller.js'
import BlogWidget from '~/components/blog/BlogWidget.vue'
import BlogNavbar from '~/components/blog/BlogNavbar.vue'
import BlogSearchBar from '~/components/blog/BlogSearchBar.vue'
import BlogPagination from '~/components/blog/BlogPagination.vue'

export default {
  name: 'Blog',
  nuxtI18n: {
    paths: {
      en: '/blog',
      it: '/blog',
      de: '/blog'
    },
  },
  components: {
    BlogWidget,
    BlogNavbar,
    BlogSearchBar,
    BlogPagination
  },
  data() {
    return {
      page: 1,
      nextPosts: [],
      loadMore: true
    }
  },
  computed:{
    queryPage() {
      return this.$route.query.p
    }
  },
  methods: {
    async getPosts() {
      const lang = this.$i18n.locales.filter((i) =>
        i.iso.includes(this.$i18n.locale)
      )[0].iso
      try {
        const blogPosts = await this.$prismic.api.query(
          this.$prismic.predicates.at('document.type', 'post'),
          {
            lang,
            orderings: '[my.post.date desc]',
            pageSize: 6,
            page: this.page + 1,
            fetchLinks: 'blog_category.name',
          }
        )
        this.page++
        blogPosts.results.length ? this.nextPosts = [...this.nextPosts, ...blogPosts.results] : this.loadMore = false
        !blogPosts.next_page ? this.loadMore = false : this.loadMore = true
      } catch (e) {
        console.log(e)
      }
    },
  },
  async asyncData({ $prismic, app, error, query, req, store }) {
    const lang = app.i18n.locales.filter((i) =>
      i.iso.includes(app.i18n.locale)
    )[0].iso
    try {
      const result = await $prismic.api.getSingle('blog', { lang })
      const blogPosts = await $prismic.api.query(
        $prismic.predicates.at('document.type', 'post'),
        {
          lang,
          orderings: '[my.post.date desc]',
          pageSize: 6,
          page: query.p || 1,
          fetchLinks: 'blog_category.name',
        }
      )
      const categories = await $prismic.api.query(
        $prismic.predicates.at('document.type', 'blog_category'),
        { lang, orderings: '[my.blog_category.uid]' }
      )
      return {
        document: result.data,
        posts: blogPosts.results,
        categories: categories.results,
        documentUid: result.uid,
        documentLang: result.lang.substr(0, 2),
        pages: blogPosts.total_pages,
      }
    } catch (e) {
      error({ message:  JSON.stringify(e), statusCode: 404})
    }
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), this.document, this.documentUid, this.documentLang)
  },
}
